import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {PageHeaderBarConfig, PageSubheaderBarConfig} from '../../../fw/pages/page-config-api';
import {FormBuilder, FormGroup} from '@angular/forms';
import {DialogService} from "@progress/kendo-angular-dialog";
import {UsedGiftcertificateService} from "./used-giftcertificate.service";
import {DynamicGridComponent} from "../../../fw/dynamic-grids/dynamic-grid.component";
import {DtoUsedGiftCertificateOverview} from "./models/DtoUsedGiftCertificateOverview";
import {ColumnDefinition} from "../../../fw/dynamic-grids/column-definition";
import {SharedService} from "../../shared/shared.service";
import {ReportPreviewComponent} from "../../shared/report-preview.component";
import {DtoUsedGiftCertificate} from "./models/DtoUsedGiftCertificate";
import {BreadcrumService, BreadcrumStep} from "../../../fw/services/breadcrum.service";

@Component({
    selector: 'ngx-gift-vouchers',
    template: require('./used-giftcertificates.component.html'),
    styles: [require('./used-giftcertificates.component.css')]
})

export class UsedGiftcertificatesComponent implements OnInit, OnDestroy {
    @ViewChild('grid', {static: false}) grid: DynamicGridComponent;
    filterForm: FormGroup = this.fb.group({
        periodId: 4,
        state: 'Alle statussen',
        from: null,
        untill: null
    });
    lSaldoPeriod: string = 'Saldo openstaand opgegeven periode:';
    periodItems: Array<{ text: string; value: number }> = [
        {text:'Vandaag', value: 0},
        {text:'Deze week', value: 1},
        {text:'Deze maand', value: 2},
        {text:'Dit jaar', value: 3},
        {text:'Laatste 2 jaar', value: 4},
        {text:'Variabele periode', value: 5}
    ];
    stateItems: Array<{ text: string; value: string }> = [
        {text: 'Alle statussen', value: 'Alle statussen'},
        {text: 'Uitgegeven', value: 'Uitgegeven'},
        {text: 'Gebruikt', value: 'Gebruikt'},
        {text: 'Afgeboekt', value: 'Afgeboekt'}
    ];
    data: DtoUsedGiftCertificateOverview;
    filterHeaderConfig: PageHeaderBarConfig = {
        title:'FILTEROPTIES',
        buttonDefinition: [
            {
                description:'ZOEKEN',
                isSmall: false,
                clickEventType: 'search'
            }
        ]
    };
    pshbConfig: PageSubheaderBarConfig = {
        title:'KADOBONNEN',
        buttonDefinition: [
            {
                description:'AFBOEKEN',
                isSmall: false,
                clickEventType: 'unbook'
            },
            {
                description:'AFDRUKKEN',
                clickEventType: 'print',
                isSmall: false
            }
        ]
    };
    voucherOverviewColumnDefinition: ColumnDefinition[] = [
        {
            label:'Datum',
            type: 'string',
            width: '120px',
            key: 'sellDateTime',
            format: '{0:dd-MM-yyyy}'
        },
        {
            label:'Nummer',
            type: 'number',
            width: '120px',
            key: 'number'
        },
        {
            label:'Uitgegeven aan',
            type: 'string',
            width: '*',
            key: 'soldTo'
        },
        {
            label:'Ingeleverd door',
            type: 'string',
            width: '*',
            key: 'usedBy'
        },
        {
            label:'Ingeleverd op',
            type: 'string',
            width: '120px',
            key: 'usedDateTime',
            format: '{0:dd-MM-yyyy}'
        },
        {
            label:'Status',
            type: 'string',
            width: '120px',
            key: 'state'
        },
        {
            label:'Waarde',
            type: 'number',
            width: '90px',
            key: 'amount',
            format: '{0:c}'
        },
    ];

    constructor(public fb: FormBuilder,
                public breadcrumService: BreadcrumService,
                public ds: UsedGiftcertificateService,
                public ss: SharedService,
                public dialogService: DialogService) {
    }

    ngOnInit() {
        let steps: Array<BreadcrumStep> = [
            { text: 'hoofdmenu', isLastStep: false },
            { text: 'administratie', isLastStep: false },
            { text: 'kadobonnen', isLastStep: true }];
        this.breadcrumService.setCurrentLocation(steps, true, 'home');

        this.filterForm.get('periodId').valueChanges.subscribe(newVal => {
            this.setFilterPeriod(newVal);
        });

        this.filterForm.get('state').valueChanges.subscribe(newVal => {
            if (newVal === 'Alle statussen')
                this.lSaldoPeriod = 'Saldo openstaand opgegeven periode:';
            else if (newVal === 'Uitgegeven')
                this.lSaldoPeriod = 'Saldo uitgegeven opgegeven periode:';
            else if (newVal === 'Gebruikt')
                this.lSaldoPeriod = 'Saldo gebruikt opgegeven periode:';
            else if (newVal === 'Afgeboekt')
                this.lSaldoPeriod = 'Saldo afgeboekt opgegeven periode:';
            this.loadData();
        });

        this.setFilterPeriod(4);
        this.loadData();
    }

    ngOnDestroy() {
    }

    loadData() {
        this.data = null;
        if (this.grid) this.grid.clearData();
        this.ds.getOverview({
            state: this.filterForm.get('state').value,
            from: this.filterForm.get('from').value,
            untill: this.filterForm.get('untill').value
        }).subscribe((res: DtoUsedGiftCertificateOverview) => {
            this.data = res;
            if (this.data.giftCertificates.length > 0) {
                this.grid.showData(this.data.giftCertificates);
            }
        });
    }

    phbBtnClicked(event) {
        if (event === 'search') {
            this.loadData();
        }
    }

    pshbBtnClicked(event) {
        if (event === 'unbook') {
            this.unbook(this.grid.getSelectedItem());
        } else if (event === 'print') {
            this.printList();
        }
    }

    printList() {
        let sortColumn = '';
        if (this.grid.grid.sort.length > 0)
            sortColumn = this.grid.grid.sort[0].field;

        const dialogRef = this.dialogService.open({
            content: ReportPreviewComponent
        });

        const dialogContent: ReportPreviewComponent = dialogRef.content.instance;
        dialogContent.dialog = dialogRef;
        dialogContent.reportName = 'OpenGiftCertificateList';
        dialogContent.reportParams = [
            {
                name: 'from',
                value: this.ss.formatDate(this.filterForm.get('from').value, 'yyyy-MM-dd')
            },
            {
                name: 'untill',
                value: this.ss.formatDate(this.filterForm.get('untill').value, 'yyyy-MM-dd')
            },
            {
                name: 'state',
                value: this.filterForm.get('state').value
            },
            {
                name: 'sortColumn',
                value: sortColumn
            }
        ];
    }

    gridRowdoubleClicked(event) {
        this.unbook(this.grid.getSelectedItem());
    }

    setFilterPeriod(periodKind: number) {
        if (periodKind == 0) {
            this.filterForm.patchValue({['from']: this.ss.getCurrentDate()}, {emitEvent: false});
            this.filterForm.patchValue({['untill']: this.ss.getCurrentDate()}, {emitEvent: false});
            this.filterForm.get('from').disable();
            this.filterForm.get('untill').disable();
        } else if (periodKind == 1) {
            this.filterForm.patchValue({['from']: this.ss.getFirstDayOfWeek(this.ss.getCurrentDate())}, {emitEvent: false});
            this.filterForm.patchValue({['untill']: this.ss.addDaysToDate(this.ss.getFirstDayOfWeek(this.ss.getCurrentDate()), 6)}, {emitEvent: false});
            this.filterForm.get('from').disable();
            this.filterForm.get('untill').disable();
        } else if (periodKind == 2) {
            this.filterForm.patchValue({['from']: this.ss.getFirstDayOfMonth(this.ss.getCurrentDate())}, {emitEvent: false});
            this.filterForm.patchValue({['untill']: this.ss.getLastDayOfMonth(this.ss.getCurrentDate())}, {emitEvent: false});
            this.filterForm.get('from').disable();
            this.filterForm.get('untill').disable();
        } else if (periodKind == 3) {
            this.filterForm.patchValue({['from']: this.ss.getFirstDayOfYear(this.ss.getCurrentDate())}, {emitEvent: false});
            this.filterForm.patchValue({['untill']: this.ss.getLastDayOfYear(this.ss.getCurrentDate())}, {emitEvent: false});
            this.filterForm.get('from').disable();
            this.filterForm.get('untill').disable();
        } else if (periodKind == 4) {
            this.filterForm.patchValue({['from']: this.ss.addYearsToDate(this.ss.getFirstDayOfYear(this.ss.getCurrentDate()), -1)}, {emitEvent: false});
            this.filterForm.patchValue({['untill']: this.ss.getLastDayOfYear(this.ss.getCurrentDate())}, {emitEvent: false});
            this.filterForm.get('from').disable();
            this.filterForm.get('untill').disable();
        } else if (periodKind == 5) {
            this.filterForm.get('from').enable();
            this.filterForm.get('untill').enable();
        }
    }

    unbook(item: DtoUsedGiftCertificate) {
        if (item && !item.isUsed) {
            this.ss.confirm('Weet u zeker dat u deze kadobon wilt afboeken? De kadobon kan hierna niet meer worden ingewisseld').subscribe((res: boolean) => {
                if (res) {
                    this.ds
                        .unbook({
                            state: this.filterForm.get('state').value,
                            from: this.filterForm.get('from').value,
                            untill: this.filterForm.get('untill').value
                        }, item.id)
                        .subscribe((res: DtoUsedGiftCertificateOverview) => {
                        this.data = res;
                        if (this.data.giftCertificates.length > 0) {
                            this.grid.showData(this.data.giftCertificates);
                        }
                    });
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/administration/used-giftcertificates/used-giftcertificates.component.ts